module.exports = __webpack_public_path__ + "img/pat-img.9e1e292a.png";